export default __webpack_public_path__ + "static/media/profile.da234316.png";